<template>
    <div>
        <div class="nav-wrap" v-if="bannerArr.length">
            <div class="banner-list">
                <el-carousel arrow="never" height="440px">
                    <el-carousel-item v-for="(item, index) in bannerArr" :key="index">
                        <img :src="item.img" :alt="item.name" @click="swiperClick(item)" />
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="content">
            <div class="top-info">
                <img class="cont" v-if="info.pc_bg_image" :src="info.pc_bg_image_url" />
                <img class="cont" v-else
                    src="https://image.sanlida.cn/static/uploads/images/2025/09/28/175904339368d8df41e4f7f.jpg" />
                <!-- <div class="top-con">
                    <div class="textbtn">
                        <img src="../assets/images/lottery/jb.png" mode="widthFix" />账户X币：{{ jifen }}
                    </div>
                    <div class="text">
                        <div v-if="info.integral_exchange">每次抽奖消耗{{ info.integral_exchange }}X币<span
                                v-if="info.integral_count">，最多{{ info.integral_count
                                }}次</span></div>
                        <div v-else>暂不可使用X币兑换抽奖次数</div>
                    </div>
                </div> -->
            </div>
            <div class="top-box">
                <div class="name-ava">
                    <img class="user-head-img"
                        :src="userInfo.avatar || $store.state.config.user_logo || $store.state.config.shop_logo || ''"
                        mode="aspectFill"></img>
                    <div>{{ (userInfo.username && userInfo.username.length > 4) ? userInfo.username.slice(0, 4) + '...'
                        :
                        userInfo.username}}</div>
                    <div>的X币账户：</div>
                </div>
                <div class="num">{{ jifen }}</div>
                <div class="text">
                    <div v-if="info.integral_exchange">每次抽奖消耗{{ info.integral_exchange }}X币<span
                            v-if="info.integral_count">，最多{{ info.integral_count }}次</span><span v-else>，不限次数</span>
                    </div>
                    <div v-else>暂不可使用X币兑换抽奖次数</div>
                </div>
                <!-- <div class="user-dy">
					<div class="dy">
						<div>今日最大抽奖次数</div>
						<div>{{info.day_count}}</div>
					</div>
					<div class="dy">
						<div>邀请的人数</div>
						<div>{{info.invite_times}}</div>
					</div>
				</div> -->
            </div>
            <div class="zp-box">
                <div class="zp-info" v-if="cjtype == 1">
                    <LuckyWheel ref="luckyWheel" width="400px" height="400px" :blocks="zpblocks" :prizes="zpprizes"
                        :buttons="zpbuttons" @start="checkStart('luckyWheel')" @end="onEnd" />
                </div>
                <div class="zp-info" v-if="cjtype == 2">
                    <LuckyGrid ref="LuckyGrid" width="334px" height="334px" :blocks="qggblocks" :prizes="qggprizes"
                        :buttons="qggbuttons" @start="checkStart('luckyGrid')" @end="onEnd" />
                </div>
            </div>
            <div class="user-list" v-if="getUserlist.length">
                <div class="user" v-for="(item, key) in getUserlist" :key="key">
                    <img :src="item.avatar" />
                    <div class="name">
                        <div>{{ item.user }}</div>
                        <div>{{ item.prize_content }}</div>
                    </div>
                </div>
            </div>
            <div class="title">抽奖记录</div>
            <div class="log-list" v-if="myPrizelist.length">
                <div class="log-item" v-for="(item, i) in myPrizelist" :key="i">
                    <div class="lo-top">
                        <div>{{ item.name }}<span class="toadd" v-if="item.prize_type == 4 && item.status == 0"
                                @click="goodadd(item)">派送地址<i class="el-icon-arrow-right"></i></span></div>
                        <div>{{ item.ctime_name }}</div>
                    </div>
                    <div>{{ item.prize_content }}</div>
                </div>
            </div>
            <div v-else class="nodata">暂无数据</div>
            <div class="title">奖项及规则</div>
            <div class="log-list rule-box">
                <div class="prize-info">
                    <div class="prizeit" v-for="item in getPrize" :key="item.id">
                        <img :src="item.img" />{{ item.content }}
                    </div>
                </div>
                <div class="prize-info" v-if="info.rule && info.rule.length">
                    <div v-for="(item, i) in info.rule" :key="i">
                        {{ item }}
                    </div>
                </div>
                <div v-else class="nodata">暂无数据</div>
            </div>
            <div style="height: 100px;"></div>
        </div>

        <el-dialog title="收货地址" :show-close="false" :visible.sync="dialogVisible" :close-on-click-modal="false">
            <div class="adress-box">
                <div class="additem" @click="addA">
                    <i class="icon iconfont iconadd"></i>
                    {{ $t('add') }}{{ $t('shippingAddress') }}
                </div>
                <div class="aditem" v-for="(item, index) in addressList" :key="index"
                    :class="{ 'active': curAddressIndex == item.id }" @click="selectCurAddress(item, index)">
                    <div class="ad-info">
                        <div>{{ item.name }} {{ item.mobile }}</div>
                        <div>{{ item.area_name }} {{ item.address }}</div>
                    </div>
                </div>
            </div>
            <div class="form-foot">
                <el-button :loading="submitStatus" style="line-height: 1;" class="foot-btn save"
                    @click="toGoods">确认</el-button>
                <div class="foot-btn cancel" @click="dialogVisible = false">{{ $t('cancel') }}</div>
            </div>
        </el-dialog>

        <el-dialog title="" class="res-dialog" :show-close="false" :visible.sync="resVisible" :close-on-click-modal="false">
            <div class="res-box">
                <img src="@/assets/images/lottery/resbg.png" />
                <div class="res-con">
					<div>{{ awardInfo.title }}</div>
					<img class="line" mode="widthFix" src="@/assets/images/lottery/resline.png" />
					<img :src="imglist[awardInfo.type]" />
					<div class="con">{{ awardInfo.content }}</div>
				</div>
                <div class="btn-box" @click="closeres">
					<img class="btn" src="@/assets/images/lottery/resbtn.png" />
					<div>继续抽奖</div>
				</div>
            </div>
        </el-dialog>

        <SelectAddress :dialogAdressVisible="dialogAddressShow" @hideDialog="hideDialog" :type="addressDialogType">
        </SelectAddress>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import SelectAddress from '@/components/address/index'
// 大转盘抽奖
import zpd from '@/assets/images/lottery/zpd.png';
import point from '@/assets/images/lottery/zppointer.png';
import mz from '@/assets/images/lottery/mz.png';
import jf from '@/assets/images/lottery/jf.png';
import yhq from '@/assets/images/lottery/yhq.png';
import ye from '@/assets/images/lottery/ye.png';
import sp from '@/assets/images/lottery/sp.png';
import spk from '@/assets/images/lottery/spk.png';
// 九宫格抽奖 
import qggbg from '@/assets/images/lottery/qggbg.png';
import btn1 from '@/assets/images/lottery/btn1.png';
import qggitem from '@/assets/images/lottery/qggitem.png';
import qggitem1 from '@/assets/images/lottery/qggitem1.png';

export default {
    name: "Lottery",
    props: {},
    components: { SelectAddress },
    data() {
        return {
            headIsFixed: true,
            showrule: false,
            showlog: false,
            lotteryId: '', // 抽奖活动id
            type: 1, // 1: 抽奖记录 2: 规则说明
            info: {}, // 抽奖信息
            jifen: 0, // 积分
            chishu: 0, // 抽奖次数
            myPrizelist: [], // 中奖列表
            cjtype: '', // 1: 转盘 2: 九宫格
            awardInfo: {}, // 抽奖结果
            bannerArr: [],
            dialogVisible: false, // 地址弹窗
            curAddressIndex: '',
            submitStatus: false, // 提交按钮状态
            win_id: '',
            dialogAddressShow: false,
            addressDialogType: 0, // 新增0 修改1
            resVisible: false, // 弹窗结果
            // 大转盘抽奖
            zpblocks: [{
                padding: '32px',
                background: '#FF893F'
            },
            {
                imgs: [{
                    src: zpd,
                    width: '390px',
                    height: '390px',
                    top: '-27px'
                }]
            }],
            zpprizes: [],
            zpbuttons: [
                {
                    radius: '20%',
                    fonts: [{
                        text: ``,
                        fontColor: '#FFFDDD',
                        fontSize: '12px',
                        top: '10px'
                    }],
                    imgs: [{
                        src: point,
                        width: '100px',
                        height: '128px',
                        top: '-78px'
                    }]
                },
            ],
            imglist: {
				0: mz,
				1: jf,
				2: yhq,
				3: ye,
				4: sp,
				5: spk
			},
            zptyplist: {
                0: {
                    background: '#FFFAEE', fonts: [{ text: '', fontColor: '#80603E', fontSize: '12px', top: '20px', lineClamp: 2, lengthLimit: '80%' }],
                    imgs: [{
                        src: mz,
                        width: '35px',
                        height: '35px',
                        top: '50px'
                    }]
                },
                1: {
                    background: '#FFBF7C', fonts: [{ text: '', fontColor: '#E7442F', fontSize: '12x', top: '20px', lineClamp: 2, lengthLimit: '80%' }],
                    imgs: [{
                        src: jf,
                        width: '35px',
                        height: '35px',
                        top: '50px'
                    }]
                },
                2: {
                    background: '#FFDFA5', fonts: [{ text: '', fontColor: '#FE3800', fontSize: '12px', top: '20px', lineClamp: 2, lengthLimit: '80%' }],
                    imgs: [{
                        src: yhq,
                        width: '35px',
                        height: '35px',
                        top: '50px'
                    }]
                },
                3: {
                    background: '#FF7C14', fonts: [{ text: '', fontColor: '#FFFBF7', fontSize: '12px', top: '20px', lineClamp: 2, lengthLimit: '80%' }],
                    imgs: [{
                        src: ye,
                        width: '35px',
                        height: '35px',
                        top: '50px'
                    }]
                },
                4: {
                    background: '#FEE6B7', fonts: [{ text: '', fontColor: '#E7442F', fontSize: '12px', top: '20px', lineClamp: 2, lengthLimit: '80%' }],
                    imgs: [{
                        src: sp,
                        width: '35px',
                        height: '35px',
                        top: '50px'
                    }]
                },
                5: {
                    background: '#FEE6B7', fonts: [{ text: '', fontColor: '#E7442F', fontSize: '12px', top: '20px', lineClamp: 2, lengthLimit: '80%' }],
                    imgs: [{
                        src: spk,
                        width: '35px',
                        height: '35px',
                        top: '50px'
                    }]
                }
            },
            // 九宫格抽奖
            tablist: [
                { x: '0', y: '0' },
                { x: '1', y: '0' },
                { x: '2', y: '0' },
                { x: '2', y: '1' },
                { x: '2', y: '2' },
                { x: '1', y: '2' },
                { x: '0', y: '2' },
                { x: '0', y: '1' },
            ], // 九宫格抽奖位置
            qggblocks: [{
                padding: '20px', imgs: [{
                    src: qggbg,
                    width: '334px',
                    height: '334px',
                }]
            }],
            qggprizes: [],
            qggbuttons: [
                {
                    x: '1', y: '1', borderRadius: '10px', shadow: '0 4 3 #791D1E',
                    fonts: [{
                        text: ``,
                        fontColor: '#FFFDDD',
                        fontSize: '12px',
                        top: '60px'
                    }],
                    imgs: [{
                        src: btn1,
                        width: '90px',
                        height: '90px', top: '0',
                    }],
                },
            ],
            userInfo: {},
        };
    },
    mounted() {
        if (!localStorage.getItem('userToken')) {
            this.$router.push({
                path: '/login'
            })
        }
        this.lotteryId = this.$route.query.id
        if (this.lotteryId) {
            this.getBanner();
            this.initdata()
            this.getmyPrize()
            this.userShipList()
            this.getUserInfo()
        }
    },
    computed: {
        addressList() {
            return this.$store.state.addressList
        },
        getUserlist() {
            let list = []
            if (this.info.winner_list && this.info.winner_list.length) {
                list = this.info.winner_list
                // for (let i = 0; i < this.info.winner_list.length; i += 2) {
                //     list.push(this.info.winner_list.slice(i, i + 2));
                // }
            }
            return list
        },
        getPrize() {
            let list = []
            if (this.info.prize && this.info.prize.length) {
                this.info.prize.forEach(item => {
                    if (item.type) {
                        list.push({
                            ...item,
                            img: this.zptyplist[item.type].imgs[0].src,
                            content: this.getPrizeMsg(item.type, item.val, item.title)
                        })
                    }
                })
            }
            return list
        }
    },
    methods: {
        ...mapActions(['getUserShipListAction']),
        closeres() {
			this.resVisible = false
			if (this.awardInfo.type == 4) {
				this.dialogVisible = true
			}
		}, 
        goodadd(data) {
            if (data.prize_type == 4 && data.status == 0) {
                this.win_id = data.id
                this.dialogVisible = true
            }
        },
        getUserInfo() {
            this.$api.userInfo().then(result => {
                if (result.status) {
                    this.userInfo = result.data;
                }
            });
        },
        addA() {
            this.dialogVisible = false
            this.dialogAddressShow = true
        },
        hideDialog(id) {
            if (id) {
                this.curAddressIndex = id
            }
            this.dialogAddressShow = false
            this.dialogVisible = true
        },
        // 抽奖商品选择收获地址
        toGoods() {
            if (!this.curAddressIndex) {
                this.$msg('请选择收获地址', 'warning')
                return
            }
            if (this.submitStatus) {
                return false;
            }
            this.submitStatus = true;
            let userToken = this.$storage.get("userToken");
            this.$api.lotteryGoods({
                token: userToken,
                address_id: this.curAddressIndex,
                log_id: this.win_id
            }).then(res => {
                if (res.status) {
                    this.$msg(res.msg, 'success')
                    this.getmyPrize()
                } else {
                    this.$msg(res.msg, 'warning')
                }
                this.dialogVisible = false
                this.submitStatus = false;
            })
        },
        // 获取收货地址列表
        userShipList() {
            this.getUserShipListAction()
        },
        //选择收货地址
        selectCurAddress(item, index) {
            this.curAddressIndex = item.id
        },
        // 获取轮播图s
        getBanner() {
            this.$api.slider({
                code: 'pc_lottery_top'
            }).then(res => {
                if (res.status) {
                    this.bannerArr = res.data.list;
                }
            });
        },
        // 查看奖品
        getmyPrize() {
            let userToken = this.$storage.get("userToken");
            this.$api.myLottery({ token: userToken, page: 1, limit: 1000, lottery_id: this.lotteryId }).then(res => {
                if (res.status) {
                    this.myPrizelist = res.data
                    this.showlog = true
                }
            })
        },
        initdata() {
            let userToken = this.$storage.get("userToken");
            this.$api.lotteryConfig({ token: userToken, lottery_id: this.lotteryId }).then(res => {
                if (res.status) {
                    this.info = res.data;
                    this.cjtype = res.data.game_type;
                    this.jifen = res.data.user.jifen;
                    this.chishu = res.data.user.day_remaining;
                    if (this.cjtype == 1) {
                        this.zpprizes = [];
                        let list = res.data.prize;
                        list.forEach(item => {
                            let one = this.zptyplist[item.type] ? JSON.parse(JSON.stringify(this.zptyplist[item.type])) : {};
                            one.fonts[0].text = item.title;
                            this.zpprizes.push({
                                ...one,
                                type: item.type,
                                id: item.id,
                                val: item.val
                            })
                        })
                        this.zpbuttons[0].fonts[0].text = `还剩${this.chishu}次`
                    } else {
                        this.qggprizes = []
                        let list = res.data.prize.slice(0, 8);
                        list.forEach((item, index) => {
                            let one = {
                                ...{
                                    borderRadius: '10px',
                                    shadow: '0 4 3 #791D1E',
                                    imgs: [{
                                        src: qggitem,
                                        width: '90px',
                                        height: '90px',
                                        top: '0',
                                        activeSrc: qggitem1,
                                    }, {
                                        src: this.zptyplist[item.type].imgs[0].src,
                                        width: '35px',
                                        height: '35px', top: '10px'
                                    }],
                                    fonts: [{ text: item.title, fontColor: '#9E2627', fontSize: '12px', top: '50px', lineClamp: 2, lengthLimit: '80%' }],
                                }, ...this.tablist[index],
                                type: item.type,
                                id: item.id,
                                val: item.val
                            };
                            this.qggprizes.push(one)
                        })
                        this.qggbuttons[0].fonts[0].text = `还剩${this.chishu}次`
                    }
                } else {
                    this.$msg(res.msg, 'error')
                    if (userToken) {
                        setTimeout(() => {
                            this.$router.replace('/');
                        }, 2000)
                    }
                }
            })
        },
        //获取显示的奖品信息
        getPrizeMsg: function (type, val, title) {
            let _this = this;
            let msg = '';
            switch (type) {
                case 1: //X币
                    msg = '中“' + title + '”奖，获取X币：' + val + '个';
                    break;
                case 2: //优惠券
                    msg = '中“' + title + '”奖，获取优惠券：“' + val + '” 一张';
                    break;
                case 3: //余额
                    msg = '中“' + title + '”奖，获取余额：' + val + '元';
                    break;
                case 4: //商品
                    msg = '中“' + title + '”奖，获取商品：“' + val + '”';
                    break;
                case 5: //视频卡
                    msg = '中“' + title + '”奖，获取视频卡：“' + val + '”';
                    break;
                default: //默认
                    msg = '未中奖';
                    break;
            }
            return msg;
        },
        checkStart(type) {
            let platform = this.info.platform
            if (platform && platform.length) {
                let type = '3'
                if (!platform.includes(type)) {
                    // this.$msg(this.info.platform_tips, 'error')
                    this.$alert(this.info.platform_tips, this.$t('tips'), {
                        confirmButtonText: this.$t('confirm'),
                        type: 'error',
                        callback: action => { },
                    })
                    return
                }
            }

            // if (this.info.integral_exchange && this.chishu < 1) {
            //     if (this.jifen < this.info.integral_exchange) {
            //         this.$alert('X币不够兑换抽奖次数了', this.$t('tips'), {
            //             confirmButtonText: this.$t('confirm'),
            //             type: 'error',
            //             callback: action => { },
            //         })
            //         return
            //     } else {
            //         if (this.info.integral_count && this.info.user.point_total >= this.info.integral_count) {
            //             this.$alert('超出最大X币兑换抽奖次数', this.$t('tips'), {
            //                 confirmButtonText: this.$t('confirm'),
            //                 type: 'error',
            //                 callback: action => { },
            //             })
            //             return
            //         }
            //     }
            // }
            // if (!this.info.integral_exchange && this.chishu < 1) {
            //     this.$alert('没有抽奖次数了', this.$t('tips'), {
            //         confirmButtonText: this.$t('confirm'),
            //         type: 'error',
            //         callback: action => { },
            //     })
            //     return
            // }
            // if (this.info.count && this.info.user.total >= this.info.count) {
            //     this.$alert('超出抽奖总次数', this.$t('tips'), {
            //         confirmButtonText: this.$t('confirm'),
            //         type: 'error',
            //         callback: action => { },
            //     })

            //     return
            // }
            // if (this.info.day_count && this.info.user.day_count >= this.info.day_count) {
            //     this.$alert('超出当日抽奖次数', this.$t('tips'), {
            //         confirmButtonText: this.$t('confirm'),
            //         type: 'error',
            //         callback: action => { },
            //     })
            //     return
            // }
            if (!this.info.user.lottery) {
                this.$alert(this.info.user.msg, this.$t('tips'), {
                    confirmButtonText: this.$t('confirm'),
                    type: 'error',
                    callback: action => { },
                })
                return
            }

            const _this = this
            if (this.info.user.free_exhausted) {
                this.$alert(`本次抽奖消耗${this.info.integral_exchange}X币，是否继续抽奖？`, this.$t('tips'), {
                    confirmButtonText: this.$t('confirm'),
                    showCancelButton: true,
                    type: 'info',
                    callback: action => {
                        if(action == 'confirm') {
                            _this.awardInfo = {}
                            if (type == 'luckyGrid') {
                                _this.onStart2()
                            }
                            if (type == 'luckyWheel') {
                                _this.onStart1()
                            }
                        }
                    },
                });
            } else {
                this.awardInfo = {}
                if (type == 'luckyGrid') {
                    this.onStart2()
                }
                if (type == 'luckyWheel') {
                    this.onStart1()
                }
            }
        },
        onStart1() {
            // 抽奖
            let userToken = this.$storage.get("userToken");
            this.$api.lottery({ token: userToken, lottery_id: this.lotteryId }).then(res => {
                if (res.status) {
                    this.$refs.luckyWheel.play()

                    let awardIndex = 0;
                    this.awardInfo = res.data.result;
                    this.win_id = res.data.win_id

                    //获取抽奖结果
                    this.zpprizes.forEach((element, index) => {
                        if (element.id == this.awardInfo.id) {
                            awardIndex = index;
                        }
                    })
                    this.$refs.luckyWheel.stop(awardIndex)

                    // let awardsConfig = this.info;
                    // this.jifen = this.chishu <= 0 ? (this.jifen - awardsConfig.integral_exchange >= 0 ? this.jifen - awardsConfig.integral_exchange : 0) : this.jifen;
                    // this.chishu = this.chishu > 1 ? this.chishu - 1 : 0;
                } else {
                    this.$msg(res.msg, 'warning')
                }
            });
        },
        onStart2() {
            // 抽奖
            let userToken = this.$storage.get("userToken");
            this.$api.lottery({ token: userToken, lottery_id: this.lotteryId }).then(res => {
                if (res.status) {
                    this.$refs.LuckyGrid.play()

                    let awardIndex = 0;
                    this.awardInfo = res.data.result;
                    this.win_id = res.data.win_id

                    //获取抽奖结果
                    this.qggprizes.forEach((element, index) => {
                        if (element.id == this.awardInfo.id) {
                            awardIndex = index;
                        }
                    })
                    this.$refs.LuckyGrid.stop(awardIndex)

                    // let awardsConfig = this.info;
                    // this.jifen = this.chishu <= 0 ? (this.jifen - awardsConfig.integral_exchange >= 0 ? this.jifen - awardsConfig.integral_exchange : 0) : this.jifen;
                    // this.chishu = this.chishu > 1 ? this.chishu - 1 : 0;
                } else {
                    this.$msg(res.msg, 'warning')
                }
            });
        },
        getJifen() {
            let userToken = this.$storage.get("userToken");
            this.$api.lotteryConfig({
                token: userToken,
                lottery_id: this.lotteryId
            }).then(res => {
                if (res.status) {
                    this.info = this.info = res.data;
                    this.jifen = res.data.user.jifen;
					this.chishu = res.data.user.day_remaining;
                    if (this.awardInfo.type == 1) {
                        this.jifen = res.data.user.jifen;
                    }
                    if (this.cjtype == 1) {
                        this.zpbuttons[0].fonts[0].text = `还剩${this.chishu}次`
                    }
                    if (this.cjtype == 2) {
                        this.qggbuttons[0].fonts[0].text = `还剩${this.chishu}次`
                    }
                }
            })
        },
        onEnd() {
            if (this.awardInfo.type > -1) {
                this.getJifen()
                this.getmyPrize()
                this.resVisible = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";

::v-deep .res-dialog .el-dialog__header {
    display: none;
}
::v-deep .res-dialog .el-dialog {
    background-color: transparent;
    box-shadow: none;
    width: 300px;
}

.res-box {
    position: relative;
    >img {
        width: 300px;
    }
    .btn-box {
		position: absolute;
		bottom: 34px;
		left: 50%;
		transform: translateX(-48%);
        cursor: pointer;
        user-select: none;
		.btn {
			width: 185px;
			height: 50px;
		}
		>div {
			position: absolute;
			left: 50%;
			top: 28%;
			transform: translate(-50%, 0);
			font-size: 14px;
			color: #CE2401;
			font-weight: 500;
		}
	}
    .res-con {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 60px;
		color: #B05226;
		font-weight: 500;
		font-size: 16px;
		max-width: 300px;
		text-align: center;
		>img {
			width: 60px;
			height: 60px;
		}
		.line {
			width: 200px;
			margin: 20px 0;
            height: auto;
		}
		.con {
			font-weight: 400;
			font-size: 12px;
			margin-top: 16px;
			text-align: left;
		}
	}
}

.top-box {
    background-color: #FFEFE4;
    margin: 0 24px;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom: 14px;

    .name-ava {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #80503D;
        font-size: 16px;
        padding: 22px 0 10px;

        .user-head-img {
            width: 18px;
            height: 18px;
            margin-right: 2px;
            border-radius: 50%;
        }
    }

    .num {
        color: #E83C3C;
        font-size: 42px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 10px;
    }

    .text {
        color: #80503D;
        font-size: 14px;
        text-align: center;
    }

    .user-dy {
        background-color: #fff;
        margin: 16px 14px 14px;
        border-radius: 6px;
        display: flex;

        .dy {
            width: 50%;
            text-align: center;
            padding: 14px 0;
            color: #80503D;
            font-size: 12px;

            >div:last-child {
                font-weight: 700;
                font-size: 20px;
                margin-top: 5px;
            }
        }
    }
}

.adress-box {
    padding: 20px 25px;
    max-height: 400px;
    overflow-y: auto;

    .aditem {
        border: 1px solid $border;
        margin-top: 14px;
        cursor: pointer;
        height: 90px;
        padding: 0 17px;
        display: flex;
        align-items: center;

        .ad-info {
            font-size: 14px;

            >div:first-child {
                font-size: 18px;
                color: #333;
                margin-bottom: 10px;
            }
        }

        &.active {
            border-color: $theme-color;
        }
    }

    .additem {
        height: 52px;
        border: 1px solid $border;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        transition: all 0.4s ease;

        &:hover {
            border-color: #333;
            color: #333;

            .icon {
                color: #333;
            }
        }
    }
}

.content {
    // padding-top: 102px;
    width: 1226px;
    margin: 0 auto;
    background-color: #FF893F;

    .top-info {
        position: relative;

        .cont {
            width: 100%;
        }

        .top-con {
            position: absolute;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);

            .textbtn {
                width: 300px;
                height: 52px;
                border-radius: 26px;
                background-color: #FF883C;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 20px;
                box-shadow: 5px 10px 10px #EA7023;

                >img {
                    width: 24px;
                    height: 24px;
                    margin-right: 2px;
                }
            }

            .text {
                margin-top: 20px;
                color: #fff;
                text-align: center;
                font-size: 16px;
            }
        }
    }

    .zp-box {
        margin-top: 10px;

        .zp-info {
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }

    .user-list {
        background-color: #FFEFE4;
        height: 108px;
        margin: 0 24px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        overflow-y: auto;
        margin-top: 30px;

        .user {
            width: calc(100% / 3);
            flex-shrink: 0;
            height: 108px;
            display: flex;
            align-items: center;

            >img {
                width: 55px;
                height: 55px;
                border-radius: 50%;
                margin: 0 10px 0 35px;
            }

            .name {
                flex: 1;
                color: #80503D;
                font-size: 12px;

                >div:first-child {
                    font-size: 18px;
                    font-weight: 500;
                    margin-bottom: 2px;
                }
            }
        }
    }

    .title {
        color: #fff;
        font-size: 32px;
        font-weight: 500;
        text-align: center;
        margin: 20px 0;
    }
}

.log-list {
    background-color: #FFEFE4;
    height: 229px;
    margin: 0 24px;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;

    .log-item {
        width: 50%;
        flex-shrink: 0;
        height: 114px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 0 36px;
        box-sizing: border-box;
        color: #80503D;
        border-bottom: 1px dashed rgba(128, 80, 61, 0.15);

        .lo-top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            >div:first-child {
                font-size: 20px;
                font-weight: 500;
                display: flex;
                align-items: center;
            }

            .toadd {
                font-size: 14px;
                font-weight: 400;
                color: #FF893F;
                margin-left: 10px;
                cursor: pointer;
                user-select: none;

                >i {
                    font-size: 12px;
                }
            }
        }
    }
}

.rule-box {
    height: auto;

    .prize-info {
        padding: 20px 36px;
        border-bottom: 1px dashed rgba(128, 80, 61, 0.15);
        width: 100%;
        box-sizing: border-box;

        .prizeit {
            margin-bottom: 10px;

            >img {
                width: 25px;
                height: 25px;
                position: relative;
                top: 6px;
            }
        }
    }
}

.nodata {
    min-height: 229px;
    color: #999;
    background-color: #FFEFE4;
    margin: 0 24px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ellipsis-line2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.nav-wrap {
    width: 1226px;
    position: relative;
    height: 440px;
    margin: 0 auto 10px;

    .banner-list {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 440px;
        z-index: 10;
        overflow: hidden;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}

.form-foot {
    display: flex;
    justify-content: center;
    padding: 20px 0;
    background: #f5f5f5;

    .foot-btn {
        width: 160px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        color: #fff;
        cursor: pointer;

        &.save {
            background: $theme-color;
            margin-right: 20px;
        }

        &.cancel {
            background: #b0b0b0;
            transition: all 0.2s;

            &:hover {
                background: #757575;
            }
        }
    }
}
</style>